
    <div class="b-inline-filter__content">
      <div>
        <input [attr.id]="id" [attr.name]="name" [(ngModel)]="value" (keyup)="wChange.emit(value)" placeholder="{{placeholder}}" />
        <div class="b-flex-grow"></div>
        <i *ngIf="value" icon="close" (click)="clear()"></i><i icon="search"></i>
      </div>
    </div>